import { globals } from "@client/globals";
import { type Api, type ApiInfo } from "@client/types/Api";
import { createSelector } from "reselect";
import { pageIdSelector, pageSelector, pageVariantIdSelector, portalIdSelector, portalSelector } from "./state";

export const createShallowEqualSelector = createSelector;

export const apiInfoSelector = createSelector(
  [portalIdSelector, pageIdSelector, pageVariantIdSelector],
  (portalId, pageId, pageVariantId): ApiInfo => ({
    baseUrl: globals.paths.baseUrl,
    baseParams: {
      portalId,
      pageId,
      pageVariantId
    },
    url: globals.paths.apiUrl
  })
);

export const basePageArgsSelector = createSelector(
  [portalSelector, pageSelector],
  (portal, page): Api.BasePageArgs => ({
    portalId: portal.id,
    baseUrl: globals.paths.apiUrl,
    pageId: page.id,
    pageVariantId: page.variantId
  })
);
